// Add browser class to body
  document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver((mutations, obs) => {
      const reviewWidgets = document.querySelectorAll('.kl_reviews__star_rating_widget');
    
      if (reviewWidgets.length) {
        reviewWidgets.forEach((item) => {
          const ratingText = item.getAttribute('aria-label');
          const target = item.querySelector('.kl_reviews__star_rating_widget__label');
    
          if (ratingText && target && target.parentNode) {
            const ratingElement = document.createElement('span');
            ratingElement.textContent = ratingText.split(' ')[0];
            ratingElement.className = 'custom-rating-value';
    
            // Prevent duplicate insertion
            if (!item.querySelector('.custom-rating-value')) {
              target.parentNode.insertBefore(ratingElement, target);
            }
          }
        });
    
        // Once done, disconnect the observer
        obs.disconnect();
      }
    });
    
    // Start observing changes to the body
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    

    const userAgent = navigator.userAgent.toLowerCase();
    let browserName = '';

    if (userAgent.includes('edge')) {
      browserName = 'edge';
    } else if (userAgent.includes('chrome')) {
      browserName = 'chrome';
    } else if (userAgent.includes('firefox')) {
      browserName = 'firefox';
    } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
      browserName = 'safari';
    } else if (userAgent.includes('opr') || userAgent.includes('opera')) {
      browserName = 'opera';
    } else if (userAgent.includes('msie') || userAgent.includes('trident')) {
      browserName = 'ie';
    }

    if (browserName) {
      document.body.classList.add('browser-' + browserName);
    }
  
{
  window.setGridHeight = (selector) => {
    let gridOffsets = [];
    let gridRowOffsets = [];

    gridOffsets = Array.from(document.querySelectorAll(selector)).map((element, index) => {
      let grid = element.closest('.grid__item') || element.closest('[data-equal]');
      element.removeAttribute('style');
      return {
        selector: element,
        selectorHeight: element.offsetHeight,
        offsetTop: grid ? grid.offsetTop : 0, // Handle cases where `grid` is null
      };
    });

    let offsets = gridOffsets.map(element => element.offsetTop);
    gridRowOffsets = [...new Set(offsets)];

    gridRowOffsets.forEach(rowOffset => {
      let rowGrids = gridOffsets.filter(grid => grid.offsetTop == rowOffset);
      let commonElementHeight = Math.max(...rowGrids.map(ele => ele.selectorHeight));
      rowGrids.forEach(grid => {
        grid.selector.style.minHeight = commonElementHeight + 'px';
      });
    });
  };

  function matchHeightCallback() {
    // console.log("Running matchHeightCallback...");
    window.setGridHeight('.product-card__info .product-card__title'); 
    window.setGridHeight('.product-card__info .f-price'); 
    window.setGridHeight('.product-card__info .product-card__swatches'); 
    window.setGridHeight('.product-card__info .product-card__actions'); 
    window.setGridHeight('.product-card__info .product-card__info_inner');
    window.setGridHeight('.product-card__info .pdp_info_swatch');
    window.setGridHeight('.multicolumn-card__info .btn');
    window.setGridHeight('.multicolumn-card__info .multicolumn-card_block');
    window.setGridHeight('.multicolumn-card .multicolumn-card__image');
    window.setGridHeight('.multicolumn-card .multicolumn-card__title');
  }
  
  if (window.location.href.includes("https://mdsolarsciences.com/products")) {
    
    // MutationObserver to detect when the product section loads
    const observer = new MutationObserver((mutations, obs) => {
      const targetElement = document.querySelector(".product-card__info"); // Change to actual class or ID
      if (targetElement) {
        matchHeightCallback();
        obs.disconnect(); // Stop observing after execution
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Fallback timeout in case the observer doesn't trigger
    setTimeout(() => {
      matchHeightCallback();
    }, 5000);
  } else {
    setTimeout(() => {
      matchHeightCallback();
    }, 2000);
  }

  // Ensure the function runs when the window resizes
  window.addEventListener('resize', function (event) {
    matchHeightCallback();
  });

  // Run the function once when the page loads
  document.addEventListener("DOMContentLoaded", matchHeightCallback);
}
{
window.selectedButton = function () {
    
    const productCards = document.querySelectorAll(".product-card__info");
       productCards.forEach((productCard) => {
           const chooseOptionsButton = productCard.querySelector(".jsselectedButton");
           const addToCartButton = productCard.querySelector(".customaddtoCartButton");
           const variantSelect = productCard.querySelector("variant-selects");
   
           if (chooseOptionsButton) {
               chooseOptionsButton.addEventListener("click", function () {
                   // Hide Choose Options button
                   chooseOptionsButton.classList.add("hidden");
   
                   // Show Add to Cart button and Variants for this specific product card
                   if (addToCartButton) addToCartButton.classList.remove("hidden");
                   if (variantSelect) variantSelect.classList.remove("hidden");
                   matchHeightCallback();
               });
           }
       });
  }
  selectedButton();

}

});

// product page - thumbnail

(function () {
  let resizeRaf;
 
  function getAnnouncementBar(root) {
    const scope = root || document;
    return (
      scope.querySelector('.js-product__media-list')
    );
  }
 
  function setAnnouncementHeight(root) {
    const bar = getAnnouncementBar(root);
    const height = bar ? bar.offsetHeight : 0;
    document.body.style.setProperty('--media-height', `${height}px`);
  }
 
  function onResize() {
    cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(() => setAnnouncementHeight());
  }
 
  document.addEventListener('DOMContentLoaded', () => {
    setAnnouncementHeight();
    window.addEventListener('resize', onResize);
  });
})();